import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'Services',
    href: '/services'
  }, {
    name: 'Packages',
    href: '/pricing'
  }, {
    name: 'About',
    href: '/about'
  }, {
    name: 'Careers',
    href: '/careers'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${isScrolled ? 'border-b border-gray-100 py-3 shadow-sm' : 'border-b border-gray-50 py-4'}`} data-id="element-199">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-200">
        <Link to="/" className="flex items-center gap-2 z-50 relative" data-id="element-201">
          <img src="https://cdn.magicpatterns.com/uploads/4WLNA9mVcANNEqY541rLKv/WhatsApp_Image_2026-05-20_at_13.32.06.jpg" alt="Global Remote Logo" className="h-10 md:h-12 w-auto object-contain" data-id="element-202" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-203">
          {navLinks.map(link => <Link key={link.name} to={link.href} className={`text-sm font-medium transition-colors ${location.pathname === link.href ? 'text-blue' : 'text-ink hover:text-blue'}`} data-id="element-204">
              {link.name}
            </Link>)}
        </nav>

        <div className="hidden md:block" data-id="element-205">
          <Link to="/contact" className="inline-flex items-center justify-center px-6 py-2.5 text-sm font-semibold text-white bg-navy hover:bg-navy-deep transition-colors rounded-md" data-id="element-206">
            Get Free Audit
          </Link>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden p-2 text-ink z-50 relative" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-207">
          {isMobileMenuOpen ? <X size={24} data-id="element-208" /> : <Menu size={24} data-id="element-209" />}
        </button>

        {/* Mobile Nav */}
        <AnimatePresence data-id="element-210">
          {isMobileMenuOpen && <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.2
        }} className="absolute top-full left-0 right-0 bg-white border-b border-gray-100 shadow-lg py-4 px-4 flex flex-col gap-4 md:hidden" data-id="element-211">
              {navLinks.map(link => <Link key={link.name} to={link.href} className={`text-base font-medium py-2 border-b border-gray-50 ${location.pathname === link.href ? 'text-blue' : 'text-ink hover:text-blue'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-212">
                  {link.name}
                </Link>)}
              <Link to="/contact" className="mt-2 inline-flex items-center justify-center px-6 py-3 text-base font-semibold text-white bg-navy rounded-md text-center" onClick={() => setIsMobileMenuOpen(false)} data-id="element-213">
                Get Free Audit
              </Link>
            </motion.div>}
        </AnimatePresence>
      </div>
    </header>;
}